// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CebTd{background-color:#ffffff4d;border-radius:3px;bottom:.2rem;color:var(--anchore-color-gray-500);font-size:.85rem;line-height:1;padding:.25rem .5rem;pointer-events:none;position:absolute;right:.5rem}.CebTd.CFFkF{color:var(--sui-color-error)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CebTd`,
	"over": `CFFkF`
};
module.exports = ___CSS_LOADER_EXPORT___;
